<template>
<md-whiteframe class="history-box">
    <md-card class="history-box-content">
        <md-card-header>
            <div class="md-title">Recent Changes</div>
        </md-card-header>
<!--         <md-card-content>
            <revisions-list :mutations="allMutations"/>
        </md-card-content> -->
    </md-card>
</md-whiteframe>
</template>

<script>
import RevisionList from '@/components/history/revisions-list';
// TESTING
import SampleData from '@/sampleData';
/**
 * History Box. Shows latest changes across projects
 */

const HistoryBox = {
    name: 'HistoryBox',
    data: function() {
        return {};
    },
    computed: {
        allMutations() {
            const results = [];
            SampleData.projects.forEach((project, p) => {
                if (project.versions) {
                    project.versions.forEach((version, v) => {
                        if (version.mutations) {
                            version.mutations.forEach((mutation, m) => {
                                const obj = {};
                                obj.id = p + '.' + v + '.' + m;
                                obj.project = project;
                                obj.version = version;
                                obj.mutation = mutation;
                                results.push(obj);
                            });
                        }
                    });
                }
            });
            return results;
        }
    },
    methods: {
    },
    components: {
        'revisions-list': RevisionList
    }
};
export default HistoryBox;

</script>

<style lang="scss">
.history-box {
    position: relative;
    width: 100%;
    padding-top: 100%;
    .history-box-content {
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        text-align: center;
        overflow: hidden;
    }
}
</style>


// WEBPACK FOOTER //
// history-box.vue?108e512b